export class UserModel {
  public userId: number;
  public name: string;
  public email: string;
  public isActive: boolean;
  public password: string;
  public password2: string;
  public roleId: number;
  public regionId: number;
  public code: string;
  public region: string;
  public phone: string;
  public createdOn: string;
}